// قاب صفحات عمومی (SCR-AUTH-001، SCR-AUTH-002): کارت میانی با برند ققنوس، بدون نشست مستأجر و منو.
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@phoenix/i18n';
import { useEffect, type ReactNode } from 'react';

export function PublicLayout({
  screenId,
  titleKey,
  titleValues,
  subtitle,
  children,
}: {
  screenId: string;
  titleKey: string;
  titleValues?: Record<string, unknown>;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  const { t } = useTranslation('iam');
  useEffect(() => {
    document.title = `${t(titleKey, titleValues)} · ${t('shell:app.staff_name')}`;
  }, [t, titleKey, titleValues]);
  return (
    <Box
      data-screen-id={screenId}
      sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 2 }}
    >
      <Paper variant="outlined" component="main" sx={{ p: { xs: 2.5, sm: 4 }, width: '100%', maxWidth: 520 }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <LocalHospitalOutlinedIcon color="primary" />
          <Typography sx={{ fontWeight: 600 }}>{t('shell:app.staff_name')}</Typography>
        </Stack>
        <Stack spacing={1} sx={{ mb: 3 }}>
          <Typography variant="h1">{t(titleKey, titleValues)}</Typography>
          {subtitle && <Typography color="text.secondary">{subtitle}</Typography>}
        </Stack>
        {children}
      </Paper>
    </Box>
  );
}
